import { render } from "./HowToResetPassword.vue?vue&type=template&id=461b927f&scoped=true"
import script from "./HowToResetPassword.vue?vue&type=script&lang=js"
export * from "./HowToResetPassword.vue?vue&type=script&lang=js"

import "./HowToResetPassword.vue?vue&type=style&index=0&id=461b927f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461b927f"]])

export default __exports__